module.exports = __webpack_public_path__ + "media/src/images/abouts/items/delivery/creambread_all-2cba3af6bb7df3ea07eaee30804b8e9a.jpg";